import * as React from 'react';

import InterdisciplinaryScienceSubjectPage from '../../../containers/InterdisciplinaryScienceSubjectPage';
import AssignmentFlowNavigation from '../assignment_flow_navigation';

const AssignInterdisciplinaryScienceSubjectPage = () => {
  return (
    <div>
      <AssignmentFlowNavigation />
      <InterdisciplinaryScienceSubjectPage />
    </div>
  )
}

export default AssignInterdisciplinaryScienceSubjectPage
